import { jsx as _jsx } from "react/jsx-runtime";
import { Separator as SeparatorPrimitive } from "radix-ui";
import { cn } from "../../lib/utils";
function Separator({ className, orientation = "horizontal", decorative = true, ...props }) {
    return (_jsx(SeparatorPrimitive.Root, { "data-slot": "separator", decorative: decorative, orientation: orientation, className: cn("shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch", className), ...props }));
}
export { Separator };
//# sourceMappingURL=separator.js.map